export const handleAnalytics = {
  type: 'function',
  required: true,
}
export const handleAnalyticsLoaded = {
  type: 'function',
  required: true,
}

export const analytics = (launchIdentity) => {
  if (!(window as any).mboCdc.mboAnalytics) {
    ;(window as any).mboCdc.mboAnalytics = {
      loadAnalytics: true,
      firstLaunchIdentity: launchIdentity,
      loadedAnalytics: false,
    }
    return (window as any).mboCdc.mboAnalytics
  }
  return {
    loadAnalytics: false,
    firstLaunchIdentity: (window as any).mboCdc.mboAnalytics
      .firstLaunchIdentity,
    loadedAnalytics: (window as any).mboCdc.mboAnalytics.loadedAnalytics,
  }
}

export const analyticsLoaded = () => {
  ;(window as any).mboCdc.mboAnalytics.analyticsLoaded = true
}
